
import { defineComponent } from "vue";

import AppHeader from "@/layouts/components/AppHeader.vue";
import AppFooter from "@/layouts/components/AppFooter.vue";

export default defineComponent({
  name: "AppLayoutDefault",
  components: {
    AppHeader,
    AppFooter,
  },
});
